/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React, { useEffect, useState } from "react";
import RegisterPageMeta from "./RegisterPageMeta";
import Layout from "../../../Layouts/Layout";
import registerPageStyle from "./registerPageStyle";
import Container from "../../../../components/Container/Container";
import AdvantagesBox from "../../../../components/Box/AdvantagesBox/AdvantagesBox";
import Paper from "@mui/material/Paper";
import { useLocation, useNavigate } from "react-router";
import AuthAction from "@/src/components/Auth/AuthAction";
import { useCustomer } from "../../../../provider/Customer/CustomerProvider";
import { Box } from "@mui/material";
import { translate } from "@/src/services/translations/translations";

export default function RegisterPage() {
  const [loginHeadline, setLoginHeadline] = useState("Registrieren");
  const { isLoggedIn } = useCustomer();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (isLoggedIn) {
      const { from } = location.state || { from: { pathname: "/servicewelt" } };
      navigate(from.pathname);
    }
  }, [isLoggedIn]);

  return (
    <Layout minimal={true}>
      <RegisterPageMeta />
      <Box sx={registerPageStyle.background}>
        <Container sx={registerPageStyle.loginContainer}>
          <Paper elevation={4}>
            <Box sx={registerPageStyle.loginTitle}>{loginHeadline}</Box>
            <Box sx={registerPageStyle.loginContent}>
              <AuthAction onActionTypeChange={(actionType) => setLoginHeadline(translate("auth." + actionType, {}))} actionType={"register"} />
            </Box>
          </Paper>
        </Container>
      </Box>
      <Container showPaddingBlock={true}>
        <Box sx={{ display: { xs: "none", lg: "block" } }}>
          <AdvantagesBox />
        </Box>
      </Container>
    </Layout>
  );
}
